<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>{{ 'Tur Detay' }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-layout>
    <v-layout row="" wrap>

      <v-flex pa-2 xs12 sm12 md12>
        <v-hover>
          <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" width="100%">
            <v-list two-line="">
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-card flat class="black--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout v-if="masterTurResult != null" row wrap>


                          <v-flex sm12 md2 justify-start>
                            <v-img :src="masterTurResult.MasterTurResimler.Resimler[0].url" height="120px" width="100%"
                              contain>
                            </v-img>
                          </v-flex>
                          <v-flex sm12 md3 class="my-auto text-xs-center">
                            <span class="title" color="blue">{{ masterTurResult.TurAdi }}</span>
                          </v-flex>
                          <v-flex sm12 md3 class="my-auto text-xs-center">
                            Başlangıç: {{ formatDate(masterTurResult.MinTarih) }} </br>Bitiş:
                            {{ formatDate(masterTurResult.MaxTarih) }} </br> {{ masterTurResult.Gece }} Gece -
                            {{ masterTurResult.Gunduz }} Gün
                          </v-flex>
                          <v-flex sm12 md2 class="my-auto text-xs-center">
                            Başlangıç Fiyat: </br><span bold> {{ masterTurResult.MinFiyat }} {{ masterTurResult.Doviz }}
                            </span> </br> <v-divider></v-divider> </br>
                          </v-flex>
                          <v-flex xs12 sm2 md2 class="my-auto text-xs-center">
                            <v-btn color="info" @click="$router.go(-1)">Listeye Dön
                              <v-icon right dark>undo</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

            </v-list>
          </v-card>
        </v-hover>
      </v-flex>


    </v-layout>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :loading="progress" :items="items.filter(x => x.KalanKontenjan > 0)" :search="search3" item-key="Id">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <tr item>
            <td>
              <v-btn v-if="props.item.Program.FiyatGruplari.length > 0" fab icon small @click="
                props.expanded = !props.expanded
                ">
                <v-icon align-center>expand_more</v-icon>
              </v-btn>
            </td>
            <td class="text-xs-left">{{ props.item.TurKodu }}</td>
            <td class="text-xs-left">{{ props.item.TurAdi }}</td>
            <td class="text-xs-left">{{ formatDate(props.item.BaslangicTarihi) }}</td>
            <td class="text-xs-left">{{  formatDate(props.item.BitisTarihi) }}</td>
          </tr>
        </template>
        <template v-slot:expand="anaprops">
          <v-card flat v-if="anaprops.item.Program.FiyatGruplari != null">
            <v-card-text>
              <v-data-table :headers="headersFiyatGrubu" :rows-per-page-items="[50]"
                :items="anaprops.item.Program.FiyatGruplari.filter(x => x.AltGruplar.length > 0)" hide-actions class="elevation-1 red" item-key="Id">
                <template slot="items" slot-scope="props">
                  <tr item>
                    <td>
                      <v-btn v-if="props.item.AltGruplar.length > 0" fab icon small @click="
                        props.expanded = !props.expanded
                        ">
                        <v-icon align-center>expand_more</v-icon>
                      </v-btn>
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.FiyatGrubu.kod }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.FiyatGrubu.isim }}
                    </td>
                  </tr>
                </template>
                <template v-slot:expand="fiyatProps">
                  <v-card flat v-if="fiyatProps.item.AltGruplar != null">
                    <v-card-text>
                      <v-data-table :headers="headersAltGrup" :rows-per-page-items="[50]"
                        :items="fiyatProps.item.AltGruplar" hide-actions class="elevation-1 red">
                        <template slot="items" slot-scope="props">
                          <tr item>
                            <td class="text-xs-left">
                              {{ props.item.AltGrup.kod }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.AltGrup.isim }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.SatisFiyat.Otel.isim }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.SatisFiyat.OtelKategori }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.SatisFiyat.SingleFarki }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.SatisFiyat.TekKisiFiyati }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.SatisFiyat.UcuncuKisiFiyati }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.SatisFiyat.CocukFiyati }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.SatisFiyat.BebekFiyati }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.SatisFiyat.ParaBirimi }}
                            </td>
                            <td class="text-xs-center"">
                              <v-flex xs12 sm2 md2 class=" my-auto text-xs-center">
                                <v-btn @click="gitTurRezervasyon(anaprops.item.Id,fiyatProps.item.FiyatGrubu.id,props.item.AltGrup.id)" color="success">Rezervasyon
                                  <v-icon right dark>playlist_add_check</v-icon>
                                </v-btn>
                              </v-flex>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                  <v-card v-else>
                    <v-card-text>
                      {{ $t('Recorded-Room-Type-not-Found') }}
                    </v-card-text>
                  </v-card>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <v-card v-else>
            <v-card-text>
              {{ $t('Recorded-Room-Type-not-Found') }}
            </v-card-text>
          </v-card>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3 }) }}
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{ $t('Close') }}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
import auth from '../../../api/auth'
import helpers from "@/components/app/customcomp/helpers.js"
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
import { ThirdPartyDraggable } from '@fullcalendar/interaction'
import tools from '../coper/tools';

export default {
  data() {
    return {
      validbanka: true,
      passwordRules: [
        v => !!v || this.$t('This-space-cannot-left-blank'),
        v => (v && v.length < 5) || this.$t('Maximum-4-characters')
      ],
      sayfayetki: {
        Screen: true,
        Update: true,
        Save: true,
        Delete: true,
        Status: true,
        Message: null,
        islem: 0,
      },
      headers: [
        {
          text: "Detay"
        }
        , {
          text: 'Tur Kodu',
          value: 'TurKodu'
        },
        {
          text: 'Tur Adı',
          value: 'TurAdi'
        },
        {
          text:'Başlangıç Tarihi',
          value:'BaslangicTarihi'
        },
        {
          text:'Bitiş Tarihi',
          value:'BitisTarihi'
        },
        {
          text: 'İslem',

        }
      ],
      headersFiyatGrubu: [
        {
          text: 'Detay'
        },
        {
          text: 'Kod',
          value: 'kod'
        },
        {
          text: 'Fiyat Grubu',
          value: 'isim'
        }
      ],
      headersAltGrup: [
        {
          text: 'Kod',
          value: 'kod'
        },
        {
          text: 'Isim',
          value: 'isim'
        },
        {
          text: 'Otel',
          value: 'Otel'
        },
        {
          text: 'Otel Kategori',
          value: 'OtelKategori'
        },
        {
          text: 'Single Farkı',
          value: 'SingleFarki'
        },
        {
          text: 'Tek Kişi Fiyatı',
          value: 'TekKisiFiyati'
        },
        {
          text: 'Üçüncü Kişi Fiyatı',
          value: 'UcuncuKisiFiyati'
        },
        {
          text: 'Çocuk Fiyati',
          value: 'CocukFiyati'
        },
        {
          text: 'Bebek Fiyatı',
          value: 'BebekFiyati'
        },
        {
          text: 'Para Birimi',
          value: 'ParaBirimi'
        },
        {
          text:'Rezervasyon'
        }
      ],
      loading: false,
      color: 'orange darken-4',
      items: [],
      search3: '',
      search: null,
      select: [],
      selected: '',
      m: false,
      k: false,
      dialog: false,
      masterTurResult: null,
      MasterTurSearchParams: {
        TurKodu: "",
        TurAdi: "",
        Gece: 0,
        Gunduz: 0,
        Aktif: true,
        Kategori: {
          id: "0",
          kod: null,
          isim: null,
          tip: 0,
          intField: null,
        },
        UrunGrubu: {
          id: "0",
          kod: null,
          isim: null,
          tip: 0,
          intField: null,
        },
        Kontenjan: 0,
        tumSirketler: false,
        sayfaAdi: null,
        Doviz: 'EUR',
      },
      cari: '',
      state: [],
      dialog_baslik: '',
      codegorunum: true,
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      timeout: 6000,
      text1: '',
      bankakod: '',
      bankaadi: '',
      progress: false,
      dictionary: {
        custom: {
          bankakod: {
            required: () => this.$t('This-space-cannot-left-blank'),
            max: () => this.$t('Must-least-4-digits'),
          },
          bankaadi: {
            required: () => this.$t('This-space-cannot-left-blank'),
          }
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.path
    })
  },
  watch: {
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    if (this.$route.query.id > 0) {
      this.isUpdate = true;
      this.getAltPaketler(this.$route.query.id);
      this.MasterTurSearchParams.Ref = this.$route.query.id
      this.MasterTurSearch();
    }
    // this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
  },
  methods: {
    yeniekle() {
      var url = '#/pakettur/masterpaketislem/'

      window.open(url, '_self')
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("tr-TR", {
        day: "numeric", // Günü gösterir
        month: "long",  // Ay adını gösterir (örnek: Aralık)
        year:"numeric",
      });
    },
    Getir(v) {
      this.k = false
      this.m = true
      this.codegorunum = false
      this.dialog = true
      this.dialog_baslik = this.$t('Update')
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    },
    getAltPaketler(turid) {
      let params = {
        MasterTurId: turid,
        tumSirketler: false,
        sayfaAdi: null,
      };
      tools.http_post(this, "MasterTurAltPaketDetayList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.items = response.body.data;

          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );

    },
    async MasterTurSearch() {
      this.loadingvmodel = true;

      try {
        const response = await tools.http_post(this, "MasterTurSearch", this.MasterTurSearchParams);
        if (response.body.Status === true) {
          this.masterTurResult = response.body.data[0];
          if (
            this.masterTurResult.MasterTurResimler &&
            this.masterTurResult.MasterTurResimler.Resimler &&
            this.masterTurResult.MasterTurResimler.Resimler.length > 0
          ) {
            const url = await this.getImage(this.masterTurResult.MasterTurResimler.Resimler[0].FileCode);
            if (url !== "hata") {
              this.masterTurResult.MasterTurResimler.Resimler[0].url = url;
            } else {
            }
          }
          this.loadingvmodel = false;
        } else {
          this.text1 = response.body.ErrorList[0];
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      } catch (error) {
        this.text1 = "Hata Oluştu, tekrar deneyiniz";
        this.snackbar = true;
        this.loadingvmodel = false;
      }
    },

    async getImage(resim) {
      const params = {
        FileCode: resim,
      };

      try {
        const response = await tools.http_post(this, "BinaryFileLoadBase64", params);
        if (response.body.Status === true) {
          const fileBase64 = response.body.data.imageBase64;
          return URL.createObjectURL(this.base64toBlob(fileBase64, "image/jpeg"));
        } else {
          return "hata";
        }
      } catch (error) {
        console.error("Ağ hatası:", error);
        return "hata";
      }
    },

    base64toBlob(base64Data, contentType = "application/octet-stream") {
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      return new Blob([byteNumbers], { type: contentType });
    },
    gitTurRezervasyon(paketId,fiyatGrubuId,AltGrupId) {
      var url = '#/pakettur/turrezervasyon?paketid=' + paketId + '&fiyatGrubuId='+fiyatGrubuId+'&altGrupId='+AltGrupId;
      window.open(url, '_self')
    },
    deletemastertur: deletemastertur,
    masterturekle: masterturekle,
    Kaydet: Kaydet,
    guncelle: guncelle,
    vazgec: vazgec
  },
  beforeMount: beforeMount,
  components: {
    yetkidialog,

  },
  vazgec: vazgec
}


function vazgec() {
  this.dialog = false
  this.search = ''

}


function Kaydet() {


  if (this.$refs.formbanka.validate()) {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


  }
}
function masterturekle() {

  this.dialog = true
  this.MasterTur = {}
  this.dialog_baslik = 'Ekle'
  this.m = false
  this.k = true
  this.codegorunum = true
  this.$validator.reset()

}

function beforeMount() {

}

function deletemastertur() {
  if (window.confirm('Seçili Turu silmek istediğinizden emin misiniz?')) {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


  }
}



function guncelle() {

}
</script>

<style></style>